import _illuminant from "./dist/illuminant";
import _workspace from "./dist/workspace";
import _matrix from "./dist/matrix";
import _degree from "./dist/degree";
import _rgb from "./dist/rgb";
import _xyz from "./dist/xyz";
var exports = {};
var illuminant = _illuminant,
    workspace = _workspace,
    matrix = _matrix,
    degree = _degree,
    rgb = _rgb,
    xyz = _xyz;
exports = {
  illuminant: illuminant,
  workspace: workspace,
  matrix: matrix,
  degree: degree,
  rgb: rgb,
  xyz: xyz
};
export default exports;
const _illuminant2 = exports.illuminant,
      _workspace2 = exports.workspace,
      _matrix2 = exports.matrix,
      _degree2 = exports.degree,
      _rgb2 = exports.rgb,
      _xyz2 = exports.xyz;
export { _illuminant2 as illuminant, _workspace2 as workspace, _matrix2 as matrix, _degree2 as degree, _rgb2 as rgb, _xyz2 as xyz };